import { useState, useEffect, useContext, memo } from "react";
import axios from "axios";
import ShowTotal from "./ShowTotal";
import {
  SHIPPING,
  DAI_TOKEN,
  USDT_TOKEN,
  BUSD_TOKEN,
  STORE_REWARDS,
} from "../helpers";

import { contextWeb3 } from "../contexts/ProviderWeb3";
import ERC20Abi from "../config/abis/ERC20.json";
import storeAbi from "../config/abis/store.json";

const styles = {
  title: {
    textAlign: "center",
    fontWeight: "200",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    fontSize: "1.5em",
  },
  methods: {
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
  },
  items: {
    marginTop: "30px",
    marginLeft: "10px",
    width: "100%",
    backgroundColor: "#222",
    padding: "10px",
    textAlign: "center",
    color: "#FFF",
    border: "0",
    textTransform: "uppercase",
    cursor: "pointer",
    borderRight: "1px solid #FFF",
  },
  error: {
    padding: "10px",
    backgroundColor: "#ffb6b6",
    color: "#c00",
    marginBottom: "20px",
  },
  success: {
    padding: "10px",
    backgroundColor: "#91ffbc",
    color: "#222",
    marginBottom: "20px",
  },
};
function Payment({ carrito, emptyCart, formShipping }) {
  const [textButtonDai, setTextButtonDai] = useState("Pagar con DAI");
  const [textButtonUsdt, setTextButtonUsdt] = useState("Pagar con USDT");
  const [textButtonBusd, setTextButtonBusd] = useState("Pagar con BUSD");
  const [textButtonBnb, setTextButtonBnb] = useState("Pagar con BNB");
  const [isError, setIsError] = useState("");
  const [success, setSuccess] = useState("");
  const [priceBNB, setPriceBNB] = useState("undefined");

  const { web3, currentAccount, balanceStore, updateBalanceToken } =
    useContext(contextWeb3);

  useEffect(() => {
    getPriceBNB();
  }, []);

  const getPriceBNB = async () => {
    const result = await axios.get(
      "https://api.binance.com/api/v3/ticker/price?symbol=BNBBUSD"
    );
    setPriceBNB(result.data.price);
  };

  const totalAPagar = () => {
    return (
      carrito.reduce((acum, p) => {
        // checar si el producto tiene descuento.
        if (p.discount) {
          // checar si tiene la cantidad de tokens para el descuento
          if (balanceStore >= p.minimum_amount_discount) {
            // aplicar descuento 120 10
            acum +=
              p.price * p.cantidad - (p.price * p.cantidad * p.discount) / 100;
          } else {
            acum += p.cantidad * p.price;
          }
        } else {
          acum += p.cantidad * p.price;
        }

        return acum;
      }, 0) + SHIPPING
    );
  };

  // DAI
  const handleDai = async () => {
    try {
      setIsError("");
      setSuccess("");
      setTextButtonDai("Espere por favor ...");
      document.getElementById("dai").style.color = "#C00";
      const token = new web3.eth.Contract(ERC20Abi, DAI_TOKEN);
      const storeRewards = new web3.eth.Contract(storeAbi, STORE_REWARDS);
      const amount = web3.utils.toWei(totalAPagar().toString(), "ether");
      // aprove methods
      await token.methods
        .approve(STORE_REWARDS, amount)
        .send({ from: currentAccount });

      // STORE REWARDS
      const result = await storeRewards.methods
        .BuyingByERC20(1, amount)
        .send({ from: currentAccount });

      console.log(result);
      document.getElementById("dai").style.color = "#fff";

      setTextButtonDai("Pagar con DAI");
      setSuccess(`Pago procesado con exito, TX: ${result.transactionHash}`);
      updateBalanceToken();
      emptyCart();
    } catch (error) {
      setTextButtonDai("Pagar con DAI");
      setIsError(error.message);
      document.getElementById("dai").style.color = "#fff";
    }
  };

  // USDT
  const handleUsdt = async () => {
    try {
      setIsError("");
      setSuccess("");
      setTextButtonUsdt("Espere por favor ...");
      document.getElementById("usdt").style.color = "#C00";
      const token = new web3.eth.Contract(ERC20Abi, USDT_TOKEN);
      const storeRewards = new web3.eth.Contract(storeAbi, STORE_REWARDS);
      const amount = web3.utils.toWei(totalAPagar().toString(), "ether");
      // aprove methods
      await token.methods
        .approve(STORE_REWARDS, amount)
        .send({ from: currentAccount });
      const result = await storeRewards.methods
        .BuyingByERC20(2, amount)
        .send({ from: currentAccount });

      console.log({ result });
      document.getElementById("usdt").style.color = "#fff";
      setTextButtonUsdt("Pagar con USDT");
      setSuccess(`Pago procesado con exito, TX: ${result.transactionHash}`);
      emptyCart();
    } catch (error) {
      setTextButtonUsdt("Pagar con USDT");
      setIsError(error.message);
      document.getElementById("usdt").style.color = "#fff";
    }
  };

  // BUSD
  const handleBusd = async () => {
    try {
      setIsError("");
      setSuccess("");
      setTextButtonBusd("Espere por favor ...");
      document.getElementById("busd").style.color = "#C00";
      const token = new web3.eth.Contract(ERC20Abi, BUSD_TOKEN);
      const storeRewards = new web3.eth.Contract(storeAbi, STORE_REWARDS);
      const amount = web3.utils.toWei(totalAPagar().toString(), "ether");
      // aprove methods
      await token.methods
        .approve(STORE_REWARDS, amount)
        .send({ from: currentAccount });
      const result = await storeRewards.methods
        .BuyingByERC20(3, amount)
        .send({ from: currentAccount });
      document.getElementById("busd").style.color = "#fff";
      setTextButtonBusd("Pagar con BUSD");
      setSuccess(`Pago procesado con exito, TX: ${result.transactionHash}`);
      emptyCart();
    } catch (error) {
      setTextButtonBusd("Pagar con BUSD");
      setIsError(error.message);
      document.getElementById("busd").style.color = "#fff";
    }
  };

  // BNB

  const handleBNB = async () => {
    try {
      setIsError("");
      setSuccess("");
      setTextButtonBnb("Espere por favor ...");
      document.getElementById("bnb").style.color = "#C00";

      const storeRewards = new web3.eth.Contract(storeAbi, STORE_REWARDS);

      await getPriceBNB();

      const total = (totalAPagar() / priceBNB).toFixed(5);

      const amount = web3.utils.toWei(total.toString(), "ether");

      // STORE REWARDS
      const result = await storeRewards.methods
        .BuyingByBNB()
        .send({ from: currentAccount, value: amount });

      console.log(result);
      document.getElementById("bnb").style.color = "#fff";

      setTextButtonBnb("Pagar con BNB");
      setSuccess(`Pago procesado con exito, TX: ${result.transactionHash}`);
      updateBalanceToken();
      emptyCart();
    } catch (error) {
      setTextButtonBnb("Pagar con BNB");
      setIsError(error.message);
      document.getElementById("bnb").style.color = "#fff";
    }
  };

  const {
    email,
    country,
    firstName,
    lastName,
    address,
    addressOptional,
    city,
    postalCode,
    phone,
  } = formShipping;

  return (
    <div>
      <h1 style={styles.title}>Payment</h1>

      <div
        className="showInfoPaymentUser"
        style={{
          color: "#333",
        }}
      >
        <span>Buyer Info:</span>

        <span
          style={{
            backgroundColor: "#FFF",
            padding: "10px",
            textTransform: "lowercase",
          }}
        >
          {email}
        </span>
        <span>
          {firstName} {lastName}
        </span>
        <span style={{ backgroundColor: "#FFF", padding: "10px" }}>
          {country}
        </span>
        <span>{address}</span>
        <span style={{ backgroundColor: "#FFF", padding: "10px" }}>
          {postalCode}
        </span>
        <span>{phone}</span>
      </div>

      {isError !== "" ? <div style={styles.error}>{isError}</div> : null}
      {success !== "" ? <div style={styles.success}>{success}</div> : null}

      {carrito.length > 0 ? (
        <>
          <div style={styles.container}>
            Total a pagar: &nbsp;
            <ShowTotal carrito={carrito} />
          </div>

          <div style={styles.methods}>
            <button id="bnb" style={styles.items} onClick={handleBNB}>
              {textButtonBnb}
              <br />
              {(totalAPagar() / priceBNB).toFixed(5)}
            </button>

            <button id="dai" style={styles.items} onClick={handleDai}>
              {textButtonDai} <br />${totalAPagar()}
            </button>
            <button id="usdt" style={styles.items} onClick={handleUsdt}>
              {textButtonUsdt} <br />${totalAPagar()}
            </button>
            <button id="busd" style={styles.items} onClick={handleBusd}>
              {textButtonBusd} <br />${totalAPagar()}
            </button>
          </div>
        </>
      ) : (
        <div>Your cart is empty...</div>
      )}
    </div>
  );
}

export default memo(Payment);
